import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface RedirectState {
  merchantUrl: string | undefined;
  failUrl: string | undefined;
  successUrl: string | undefined;
  processingUrl: string | undefined;
  redirectTimeout: number | undefined;
  redirectType: string | undefined;
}

const initialState: RedirectState = {
  merchantUrl: undefined,
  failUrl: undefined,
  successUrl: undefined,
  processingUrl: undefined,
  redirectTimeout: 30,
  redirectType: undefined,
};

const redirectSlice = createSlice({
  name: 'redirect',
  initialState,
  reducers: {
    setRedirectData: (state, action: PayloadAction<Partial<RedirectState>>) => {
      Object.assign(state, action.payload);
    },

    resetRedirectData: () => initialState,
  },
});

export const { setRedirectData, resetRedirectData } = redirectSlice.actions;

// selectors
export const redirectSelector = (state: { redirect: RedirectState }) => state.redirect;

export const merchantUrlSelector = (state: { redirect: RedirectState }) => state.redirect.merchantUrl;
export const redirectTypeSelector = (state: { redirect: RedirectState }) => state.redirect.redirectType;

export default redirectSlice.reducer;
